// extracted by mini-css-extract-plugin
export default {"nav_wrapper":"Navigation_nav_wrapper__ej6Rc","nav":"Navigation_nav__-NSTY"};